<!--
  재귀 List Item 컴포넌트
  1-Depth 이상의 Dropdown 혹은 Context-menu
  Root Component : q-list

  @since 2020-01-06
  @author kdydesign.kim

  @modify mk.ko
    * (2021-07-06) TAMS 재귀 DL Component 마우스 오버/하버 시 동작 불편 개선
-->

<template>
  <q-list link
          separator
          no-border
          v-close-overlay="closeOverlay"
  >
    <!-- TAMS 제외 -->
<!--    v-auth-level="getAuthLevel(item)"-->
<!--    :ha-force="haForce || item.haForce"-->
<!--    v-feature="getFeature(item)"-->
    <template v-for="item in list">
      <!-- TAMS -->
      <q-item-separator inset v-if="item.separator" class="separator-item marL5 marR5"/>

      <!-- TAMS (mouseleave.native 이벤트 제거) -->
<!--      @mouseleave.native="onHide(item, $event)"-->
      <q-item :key="getKey(item)"
              :disable="getDisable(item)"
              @click.native="onEvent(item)"
              @mouseover.native="onShow(item, $event)"
              :style="{'padding-right': renderSubMenu(item) ? '0px !important' : ''}">

        <q-item-main>
          <q-item-tile label>{{item.label}}</q-item-tile>
        </q-item-main>

        <q-item-side v-if="renderSubMenu(item)"
                     right
                     icon="keyboard_arrow_right"/>

<!--        TODO: sub items 나오지 않는 이슈로 주석처리함 @mouseleave.native="onSubHide(item, $event)"-->
        <q-popover v-if="renderSubMenu(item)"
                   :ref="`popover_${getKey(item)}`"
                   anchor="top right"
                   self="top left"
                   class="animate-none"
                   @mouseover.native="onSubShow(item, $event)"
        >
          <recursive-dropdown :list="item.items"
                              :closeOverlay="closeOverlay"
                              :subComp="true"
                              :disable="getDisable(item.items)"
                              :path="`${path === '' ? '' : `${path}.`}${item.key}`"
                              @onClick="onEvent"
          />
        </q-popover>
      </q-item>
    </template>
  </q-list>
</template>

<script>
  export default {
    name: 'RecursiveDropdown',
    props: {
      list: {
        type: Array,
        default: () => []
      },
      // TODO: 침입탐지 프로파일에서 필요하므로 추가함
      path: {
        type: String,
        default: ''
      },
      disable: {
        type: [Boolean, Function],
        default: false
      },
      clickEvent: {
        type: Function,
        default: void 0
      },
      haForce: {
        type: Boolean,
        default: false
      },
      closeOverlay: {
        type: Boolean,
        default: true
      },
      subComp: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        subMap: void 0
      }
    },
    mounted () {
      this.subMap = new Map()
    },
    beforeDestroy () {
      this.subMap.clear()
      this.subMap = void 0
    },
    methods: {
      getFeature (item) {
        return _.has(item, 'feature') ? item.feature : void 0
      },
      getKey (item) {
        return item.type || item.key
      },
      getDisable (item) {
        if (this.disable && !_.isArray(item)) {
          if (_.isFunction(this.disable)) {
            return this.disable(item)
          } else {
            return this.disable
          }
        } else {
          if (_.isFunction(item.disable)) {
            return item.disable(item)
          } else {
            return item.disable || false
          }
        }
      },
      getAuthLevel (item) {
        return item.authForce
      },
      onShow (item, evt) {
        try {
          if (_.has(item, 'items')) {
            const key = `popover_${this.getKey(item)}`
            this.subMap.set(key, {
              show: true,
              item
            })
            if (this.subMap.size > 1) {
              this.subMap.forEach((v, k) => {
                if (k !== key) {
                  const item = this.subMap.get(k).item
                  this.onSubHide(item, {toElement: true})
                  this.subMap.delete(k)
                }
              })
            }

            this.$refs[key][0].show()
          } else {
            if (this.subMap.size > 0) {
              this.subMap.forEach((v, k) => {
                const item = this.subMap.get(k).item
                this.onSubHide(item, {toElement: true})
                this.subMap.delete(k)
              })
            }
          }
        } catch (e) {
          this.$log('[Recursive Dropdown GUI Error (onShow)]', e)
        }
      },
      onEvent (item) {
        try {
          if (item.disable) {
            let isDisableFlag = false

            if (_.isFunction(item.disable)) {
              isDisableFlag = item.disable()
            } else {
              isDisableFlag = item.disable
            }

            if (isDisableFlag) {
              return void 0
            }
          }
          // 자식 노드가 있는 부모노드를 마우스 클릭시, 부모노드가 포함된 창이 사라지고, 자식 노드만 남는경우 발생.
          // 클릭이벤트 발생시 창을 닫도록 보완.
          if (_.has(item, 'items')) {
            return void 0
          }

          // TAMS
          this.onSubHide(item, {toElement: true})

          if (_.has(item, 'click')) {
            item.click(item, this.path)
          } else {
            this.$emit('onClick', item, this.path)
          }
        } catch (e) {
          this.$log('[Recursive Dropdown GUI Error (onEvent)]', e)
        }
      },
      onSubShow (item, evt) {
        try {
          if (evt.toElement) {
            const key = `popover_${this.getKey(item)}`
            this.subMap.set(key, {
              show: true,
              item
            })
          }
        } catch (e) {
          this.$log('[Recursive Dropdown GUI Error (onSubShow)]', e)
        }
      },
      onSubHide (item, evt) {
        try {
          if (evt.toElement) {
            const key = `popover_${this.getKey(item)}`
            this.subMap.set(key, {
              show: false,
              item
            })

            _.forEach(_.keys(this.$refs), (ref) => {
              if (this.$refs[ref] && this.$refs[ref].length > 0) {
                this.$refs[ref][0].hide()

                // 상위 pop-over hide
                if (this.$refs[ref][0].scrollTarget) {
                  if (this.$refs[ref][0].scrollTarget.__vue__ &&
                    this.$refs[ref][0].scrollTarget.className.indexOf('child-popup') > -1) {
                    this.$refs[ref][0].scrollTarget.__vue__.hide()
                  }
                }

                // 하위 pop-over hide
                if (this.$refs[ref][0].$children.length > 0) {
                  this.recursiveHide(this.$refs[ref][0].$children)
                }
              }
            })
          }
        } catch (e) {
          this.$log('[Recursive Dropdown GUI Error (onSubHide)]', e)
        }
      },
      onHide (item, evt) {
        try {
          _.forEach(_.keys(this.$refs), (ref) => {
            if (this.$refs[ref] && this.$refs[ref].length > 0) {
              if (evt.relatedTarget.__vue__) {
                if (!evt.relatedTarget.__vue__.subComp &&
                  !evt.relatedTarget.__vue__.$parent.subComp &&
                  !evt.relatedTarget.__vue__.$parent.$parent.subComp) {
                  this.$refs[ref][0].hide()
                }
              } else {
                // context-menu leave 이벤트 대상이 jsGrid 인 경우
                if (evt.relatedTarget.classList.length > 0) {
                  if (evt.relatedTarget.classList[0].indexOf('jsgrid') > -1) {
                    this.$refs[ref][0].hide()
                  }
                }
              }
            }
          })
        } catch (e) {
          this.$log('[Recursive Dropdown GUI Error (onHide)]', e)
        }
      },
      renderSubMenu (item) {
        return _.has(item, 'items')
      },
      recursiveHide (childPopOver) {
        _.forEach(childPopOver, (child) => {
          if (_.has(child, 'hide')) {
            child.hide()
          }

          if (child.$children.length > 0) {
            this.recursiveHide(child.$children)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .separator-item {
    border-top: 1px solid #0061cc !important;
  }
</style>
